import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useFontsSelectorStyles = makeStyles({
  sectionContainer: {
    marginTop: tokens.spacingVerticalL,
  },
  fontsContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXXL,
    marginTop: tokens.spacingVerticalS,
  },
  fontSelectContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalS,
    rowGap: tokens.spacingVerticalS,
  },
  fontSelect: {
    minWidth: '330px',
  },
  fontWeightSelect: {
    '& > input': {
      maxWidth: '100px',
    },
  },
  fontSelectContainerHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalS),
  },
});
